import { Stack } from '@mantine/core';
import dayjs from 'dayjs';

import { Text } from '../../../../../ui-library/typography/typography';

export const FocusChartTooltip = (props: any) => {
  const { active, payload, label, selectionNames, selectionColors } = props;
  if (!active || !payload || !payload.length) {
    return null;
  }

  return (
    <Stack
      gap="xs"
      p="xs"
      style={{
        backgroundColor: 'white',
        borderRadius: 4,
        boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
        maxWidth: 300,
      }}
    >
      <Text size="small" weight="medium">
        {dayjs(label).format('MMM, YYYY')}
      </Text>

      <Stack gap="xs">
        {payload.map((entry: any) => {
          const itemId = entry.dataKey as string;
          if (itemId === 'date') return null;

          return (
            <div
              key={itemId}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 8,
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <div
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: '50%',
                    backgroundColor: selectionColors[itemId],
                  }}
                />
                <Text size="small">{selectionNames[itemId]}</Text>
              </div>
              <Text size="small" weight="medium">
                {entry.value !== undefined ? entry.value.toFixed(1) : 'N/A'}%
              </Text>
            </div>
          );
        })}
      </Stack>
    </Stack>
  );
};
